module.exports = __webpack_public_path__ + "static/media/mechanic_truck_alt.a03addeb.svg";